import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import {
  DIA_CHI_CABIN,
  tenKhuVucTheoId,
  timCabinTheoId,
} from '../constants/cabin.constant';

/**
 * Chặn học viên trước khi họ chọn một cabin KHÔNG nằm ở cơ sở chính.
 *
 * ── Vì sao cần ──
 * Ba cabin Dĩ An ở cùng một chỗ, Phú Giáo thì cách đó hàng chục cây số. Học
 * viên quen "đi cabin là về Dĩ An" nên hay đến nhầm, và khi biết thì đã mất
 * buổi.
 *
 * ── Vì sao chặn ở bước CHỌN, không phải bước đặt ──
 * Chặn sớm thì học viên chưa mất công chọn ngày, chọn ca. Địa chỉ vẫn được
 * nhắc lại lần nữa trong hộp xác nhận đặt lịch, vì giữa hai thời điểm đó họ
 * còn thao tác một lúc.
 *
 * ── Vì sao nút không ghi "Đồng ý" ──
 * Hộp thoại xác nhận bị bấm theo phản xạ. Nút ghi thẳng tên địa điểm — "Tôi sẽ
 * đến Phú Giáo" — thì muốn bấm nhầm cũng phải đọc qua chữ đó. Nút còn lại đưa
 * đường lui rõ ràng thay vì chỉ có dấu X.
 */
export default function CanhBaoKhacDiaChiModal({ cabinId, onXacNhan, onBo }) {
  const cabin = timCabinTheoId(cabinId);
  const khuVuc = tenKhuVucTheoId(cabinId);

  return (
    <Modal show={!!cabinId} onHide={onBo} centered>
      <Modal.Header closeButton>
        <Modal.Title className='h5'>Cabin này không ở Dĩ An</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Bạn đang chọn <strong>{cabin?.name}</strong>. Cabin này ở{' '}
          <strong>{khuVuc}</strong>, khác địa chỉ với ba cabin Dĩ An.
        </p>
        <div className='p-3 rounded' style={{ background: '#fff4e5' }}>
          <div className='fw-bold mb-1'>Địa chỉ cần đến:</div>
          <div>{DIA_CHI_CABIN[cabinId]}</div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outline-secondary' onClick={onBo}>
          Chọn cabin khác
        </Button>
        <Button variant='primary' onClick={onXacNhan}>
          Tôi sẽ đến {khuVuc}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
